export default {
  APP_NAME: process.env.REACT_APP_NAME,
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  SHOW_DESIGNER_BUTTON: process.env.REACT_APP_SHOW_DESIGNER_BUTTON,
  SHOW_FORCE_UPDATE_BUTTON: process.env.REACT_APP_SHOW_FORCE_UPDATE_BUTTON,
};
